import { render, staticRenderFns } from "./EducationDegrees.vue?vue&type=template&id=278e033b"
import script from "./EducationDegrees.vue?vue&type=script&lang=js"
export * from "./EducationDegrees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports